<div *ngIf="isOpen" class="fixed inset-0 z-50 flex justify-end backdrop-blur-md" (click)="onClose()">
    <div class="glass-panel drawer-panel w-full h-full flex flex-col overflow-hidden border-l shadow-2xl"
        [ngClass]="maxWidth" (click)="$event.stopPropagation()">
        <div class="flex-none flex items-center justify-between p-6 drawer-divider border-b">
            <h3 class="text-xl font-bold drawer-title">{{ title }}</h3>
            <button (click)="onClose()" class="drawer-close transition-colors">
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12">
                    </path>
                </svg>
            </button>
        </div>
        <div class="flex-1 p-6 overflow-y-auto">
            <ng-content></ng-content>
        </div>
        <div class="flex-none flex justify-end gap-4 p-6 bg-black/[0.03] dark:bg-white/[0.03] drawer-divider border-t">
            <ng-content select="[footer]"></ng-content>
        </div>
    </div>
</div>
